// extracted by mini-css-extract-plugin
export default {"customExpandIcon":"CollapsePanel_customExpandIcon__lUK6N","collapse":"CollapsePanel_collapse__W48TI","rotate":"CollapsePanel_rotate__htw7E"};